<template>
  <div v-if="group">
    <div class="gp-has-header" v-if="!group.homePageBanner">&nbsp;</div>
    <div :class="'group-banner mb-4 animated slideInDown group-banner-' + group.bannerSize"
         v-if="group.homePageBanner"
         v-bind:style="'background-image: url(\'' + group.banner + '\'); background-position-y:' + group.bannerYPosition">
      <mdb-container>
        <div class="group-overlay-container text-left">
          <router-link v-if="group.homeUrl" :to="group.homeUrl" class="group-overlay-name"><mdb-icon v-if="!suppressHomeIcon" icon="home" class="pr-2"></mdb-icon>{{ group.name }}
          </router-link>
        </div>
        <div v-if="group.balance>0 &&!showBannerEdit" class="text-right banner">
          <mdb-btn
            color="warning"
            icon="money-bill-wave"
            rounded size="sm" @click="navBilling">Balance Due
          </mdb-btn>
        </div>
      </mdb-container>
    </div>
    <div v-if="group.balance>0 &&!showBannerEdit && !group.homePageBanner" class="text-right banner">
      <mdb-btn
        color="warning"
        icon="money-bill-wave"
        rounded size="sm" @click="navBilling">Balance Due
      </mdb-btn>
    </div>

    <div v-if="showBannerEdit" class="text-right banner-edit">
      <div class="text-info mb-1">Banner</div>
      <div v-if="group.homePageBanner">
        <select id="banner-size" v-model="group.bannerSize"
                class="browser-default custom-select">
          <option value="small">Small</option>
          <option value="medium">Medium</option>
          <option value="large">Large</option>
        </select>
        <div class="mb-2" @click="bannerYPosition('top')">
          <a role="button">
            Top
            <mdb-icon icon="arrow-up"/>
          </a>
        </div>

        <div class="mb-2" @click="bannerYPosition('center')">
          <a role="button">
            Center
            <mdb-icon icon="arrows-v"/>&nbsp;
          </a>
        </div>

        <div class="mb-2" @click="bannerYPosition('bottom')">
          <a role="button">
            Bottom
            <mdb-icon icon="arrow-down"/>
          </a>
        </div>
        <div class="mb-2" @click="fineTune=true">
          <a role="button">
            Fine Tune
            <mdb-icon icon="sliders-v"/>
          </a>
        </div>

        <div @click="removeBannerModal = true">
          <a role="button">
            Remove Banner
            <mdb-icon icon="eye-slash"/>
          </a>
        </div>
      </div>
      <div v-if="!group.homePageBanner">
        <div @click="restoreBanner">
          <a role="button">
            Restore
            <mdb-icon icon="eye"/>
          </a>
        </div>
        <div @click="bannerPhoto">
          <a role="button">
            Change Image
            <mdb-icon icon="camera"/>
          </a>
        </div>
      </div>

      <div @click="bannerPhoto">
        <a role="button">
          Change
          <mdb-icon icon="camera"/>
        </a>
      </div>
    </div>

    <mdb-modal side position="bottom-left" :show="fineTune" @close="fineTune=false" size="sm">
      <mdb-modal-header :close="true" class="primary-color-dark text-white">
        <h5>Fine Tune Banner Position</h5>
      </mdb-modal-header>
      <mdb-modal-body>
        <div class="mb-2" @click="bannerYPosition('top')">
          <a role="button">
            Top
            <mdb-icon icon="arrow-up"/>
          </a>
        </div>
        <div class="mb-2" @click="bannerYPosition('10%')">
          <a role="button">
            10%
          </a>
        </div>
        <div class="mb-2" @click="bannerYPosition('20%')">
          <a role="button">
            20%
          </a>
        </div>
        <div class="mb-2" @click="bannerYPosition('30%')">
          <a role="button">
            30%
          </a>
        </div>
        <div class="mb-2" @click="bannerYPosition('40%')">
          <a role="button">
            40%
          </a>
        </div>

        <div class="mb-2" @click="bannerYPosition('center')">
          <a role="button">
            Center
            <mdb-icon icon="arrows-v"/>&nbsp;
          </a>
        </div>

        <div class="mb-2" @click="bannerYPosition('60%')">
          <a role="button">
            60%
          </a>
        </div>
        <div class="mb-2" @click="bannerYPosition('70%')">
          <a role="button">
            70%
          </a>
        </div>
        <div class="mb-2" @click="bannerYPosition('80%')">
          <a role="button">
            80%
          </a>
        </div>
        <div class="mb-2" @click="bannerYPosition('90%')">
          <a role="button">
            90%
          </a>
        </div>

        <div class="mb-2" @click="bannerYPosition('bottom')">
          <a role="button">
            Bottom
            <mdb-icon icon="arrow-down"/>
          </a>
        </div>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal :show="bannerEdit " @close="bannerEdit=false" size="lg">
      <mdb-modal-header :close="true" class="primary-color text-white">
        <h3 v-if="editType=='select'">Choose a Banner</h3>
        <h3 v-if="editType=='upload'">Upload a Banner</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <div v-if="editType=='select'">
          <div class="text-left">
            <p>Click/tap your group name to select the banner you would like to use.</p>
            <p>Any images in your "Banners" folder from your image library are shown below along with some
              system images you may wish to use.
            </p>
            <p class="text-warning">
              Even if you hide the banner from your home page, your banner image is used to represent your
              group elsewhere in the system, including on the Explore Groups page.
            </p>
            <mdb-btn @click.native="editType='upload'" size="md">
              <mdb-icon icon="image"/>
              Upload New Image
            </mdb-btn>
          </div>

          <div v-bind:id="banner.id" v-for="banner in banners.customImages">
            <div class="group-banner group-banner-large mb-4" v-bind:style="'background-image: url(\'' + banner.url + '\');'">
              <div class="group-overlay-container text-left">
                <a @click="selectBanner('custom',banner)" role="button">{{ group.name }}</a>
              </div>
            </div>
          </div>
          <div v-bind:id="banner.id" v-for="banner in banners.defaultImages">
            <div class="group-banner group-banner-large mb-4" v-bind:style="'background-image: url(\'' + banner.url + '\');'">
              <div class="group-overlay-container text-left">
                <a @click="selectBanner('default',banner)" role="button">{{ group.name }}</a>
              </div>
            </div>
          </div>
        </div>
        <div v-if="editType=='upload'">
          <div class="text-left">
            <p>
              When choosing a custom image for your banner, keep in mind that the image will be cropped
              (from top left) and adjusted to fit the screen. Experiment with
              different images and screen sizes to ensure that your banner looks good on all devices.
              It's best not to use images with logos or words as the cropping could negatively affect how it appears.
            </p>
            <mdb-btn @click.native="editType='select'" size="md">
              <mdb-icon icon="image"/>
              Back to Image List
            </mdb-btn>
            <mdb-file-input v-on:getValue="uploadFile"/>
          </div>

        </div>

      </mdb-modal-body>
    </mdb-modal>
    <mdb-modal size="lg" v-if="group && group.hasRequiredQuestions && !hideQuestions && !suppressQuestions">
      <mdb-modal-header class="secondary-color" :close="false">

      </mdb-modal-header>
      <mdb-modal-body>
        <answers :group="group" :show-all="false" @submit="submittedAnswers"></answers>
      </mdb-modal-body>
    </mdb-modal>

    <yes-no-modal question="Are you sure you wish to remove the banner from your home page?"
                  additional-text="Without a system-generated banner, your group name will also not appear. You should create a home page section at the top with this information."
                  @yes="removeBanner" @no="removeBannerModal = false"
                  v-if="removeBannerModal"/>
  </div>
</template>

<script>
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbFileInput,
  mdbIcon,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow
} from 'mdbvue';
import api from '../../services/groupsPlaceApi.js'
import Answers from './Answers'
import YesNoModal from "../common/YesNoModal";

export default {
  name: 'Banner',
  components: {
    YesNoModal,
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbBtn,
    mdbFileInput,
    Answers
  },
  props: {
    group: {
      type: Object,
      default: null
    },
    showBannerEdit: {
      type: Boolean,
      default: false
    },
    suppressQuestions: {
      type: Boolean,
      default: false
    },
    suppressHomeIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bannerEdit: false,
      editType: "select",
      banners: [],
      uploadedImage: null,
      hideQuestions: false,
      fineTune: false,
      removeBannerModal: false
    }
  },
  computed: {
    bannerSize() {
      return this.group.bannerSize
    }
  },
  mounted() {

  },
  methods: {
    navBilling() {
      this.$router.push("/group/" + this.group.vanityPath + "/billing")
    },
    bannerYPosition(pos) {
      this.$store.dispatch("setExecuting", true)
      api.post("/group/bannerPosition/" + this.group.vanityPath, {position: pos}).then(
        (details) => {
          this.group.bannerYPosition = pos
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    submittedAnswers(data) {
      this.hideQuestions = true
      if (!data) location.reload()
      this.$store.dispatch("setExecuting", true)
      api.post("/member/answers/" + this.group.vanityPath, {questions: data}).then(
        (details) => {
          location.reload()
        },
        (error) => {
          this.$notify.error({message: "Could not post answers -> " + error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    uploadFile: async function (file) {
      this.bannerEdit = false
      await this.$store.dispatch("setExecuting", true)
      let uploadResults = await api.groupUploadImage(this.group.id, file[0])
      if (!uploadResults.success) {
        this.$notify.error({message: uploadResults.message, timeOut: 5000})
        await this.$store.dispatch("setExecuting", false)
        return
      }

      api.post(`/group/newBanner/${this.group.vanityPath}/?requestId=${uploadResults.uploadRequest.id}`,
               {}).then(
        (results) => {
          this.group.banner = results.data.bannerUrl
          this.$notify.success({message: "Banner uploaded successfully.", timeOut: 3000})
        },
        (error) => {
          this.$notify.error({message: "Error uploading file.", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    removeBanner: function () {
      this.removeBannerModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/group/banner/" + this.group.vanityPath, {bannerType: "remove"}).then(
        (details) => {
          this.$store.dispatch("toggleBanner")
          this.group.homePageBanner = !this.group.homePageBanner
          this.$notify.success({message: "Banner removed successfully.", timeOut: 3000})
        },
        (error) => {
          this.$notify.error({message: "Could not remove banner.", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    restoreBanner: function () {
      this.removeBannerModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/group/banner/" + this.group.vanityPath, {bannerType: "system"}).then(
        (details) => {
          this.$store.dispatch("toggleBanner")
          this.group.homePageBanner = !this.group.homePageBanner
          this.$notify.success({message: "Banner restored successfully.", timeOut: 3000})
        },
        (error) => {
          this.$notify.error({message: "Could not restore banner.", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    selectBanner: function (type, banner) {
      this.bannerEdit = false
      this.$store.dispatch("setExecuting", true)
      api.post("/group/banner/" + this.group.vanityPath, {bannerType: type, id: banner.id}).then(
        (details) => {
          this.group.banner = banner.url
          this.$notify.success({message: "Banner changed successfully.", timeOut: 3000})
        },
        (error) => {
          this.$notify.error({message: "Could not get banners at this time.", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    bannerPhoto: function () {
      this.editType = "select"
      this.$store.dispatch("setExecuting", true)
      this.error = null
      api.get("/group/banner/" + this.group.vanityPath, {}).then(
        (details) => {
          this.banners = details.data
          this.bannerEdit = true
        },
        (error) => {
          this.$notify.error({message: "Could not get banners at this time.", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  },
  watch: {
    group: function (n, o) {
      if (this.group.id) {
        this.$store.dispatch("setCurrentGroup", this.group)
      }
    },
    bannerSize: function (n,o) {
      if (!o) return
      if (n==o) return
      this.$store.dispatch("setExecuting", true)
      api.post("/group/bannerSize/" + this.group.vanityPath, {size: n}).then(
        () => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};
</script>

<style scoped>

@media screen and (max-width: 749px ) {
  .group-overlay-container {
    font-size: 175%;
    width: 84%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 1.75em;
  }

  .group-banner {
    margin-top: 64px;
    display: block;
    width: 100%;
    background-size: cover;
    padding-top: 165px;
    position: relative;
  }

  .group-overlay-name {
    padding-left: 10px;
  }

  .banner-edit {
    background-color: #ffffff;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 5000;
  }

}

@media screen and (min-width: 750px ) {
  .group-overlay-container {
    font-size: 2.5rem;
    padding-left: 1em;
    padding-right: 1em;
    margin-bottom: 30px;
  }

  .group-overlay-name {
    opacity: 1;
    font-size: 2.5rem;
    padding-left: 10px;
  }

  .group-banner {
    margin-top: 74px;
    display: block;
    width: 100%;
    background-size: cover;
    position: relative;
  }

  .group-banner-large {
    padding-top: 25%;
  }

  .group-banner-medium {
    padding-top: 15%;
  }

  .group-banner-small {
    padding-top: 10%;
  }

  .banner-edit {
    z-index: 2000;
    background-color: #ffffff;
    opacity: 0.8;
    position: absolute;
    top: 80px;
    right: 0;
    padding: 10px;
  }


}

.group-overlay-container {
  background-color: #ffffff;
  opacity: 0.8;
  position: absolute;
  bottom: 0;
  left: 0;
}

.banner-edit-overlay {
  background-color: #ffffff;
  opacity: 0.8;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 10px;
  cursor: pointer;
}

</style>
